import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_BACKEND_URL + '/api';

// Create axios instance with interceptors
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to requests if available
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle token expiration
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Auth APIs
export const authAPI = {
  signup: async (data) => {
    const response = await api.post('/auth/signup', data);
    return response.data;
  },
  login: async (data) => {
    const response = await api.post('/auth/login', data);
    return response.data;
  },
  googleAuth: async (googleToken) => {
    const response = await api.post('/auth/google', { googleToken });
    return response.data;
  },
  getMe: async () => {
    const response = await api.get('/auth/me');
    return response.data;
  },
};

// Assessment APIs
export const assessmentAPI = {
  create: async (data) => {
    const response = await api.post('/assessments', data);
    return response.data;
  },
  getAll: async () => {
    const response = await api.get('/assessments');
    return response.data;
  },
  getById: async (id) => {
    const response = await api.get(`/assessments/${id}`);
    return response.data;
  },
  delete: async (id) => {
    const response = await api.delete(`/assessments/${id}`);
    return response.data;
  },
};

// Custom Domains APIs
export const domainAPI = {
  save: async (data) => {
    const response = await api.post('/domains/custom', data);
    return response.data;
  },
  get: async () => {
    const response = await api.get('/domains/custom');
    return response.data;
  },
};

// AI Coaching APIs
export const coachingAPI = {
  ask: async (data) => {
    const response = await api.post('/coaching/ask', data);
    return response.data;
  },
  getHistory: async () => {
    const response = await api.get('/coaching/history');
    return response.data;
  },
};

// Payment APIs
export const paymentAPI = {
  createSubscription: async (data) => {
    const response = await api.post('/payments/create-checkout-session', data);
    return response.data;
  },
  getSessionStatus: async (sessionId) => {
    const response = await api.get(`/payments/session-status/${sessionId}`);
    return response.data;
  },
  executePayPalPayment: async (paymentId, payerId, planId, userId) => {
    const response = await api.post('/payments/paypal-execute', null, {
      params: { payment_id: paymentId, payer_id: payerId, plan_id: planId, user_id: userId }
    });
    return response.data;
  },
};

// Admin APIs
export const adminAPI = {
  getAllUsers: async (adminPassword) => {
    const response = await api.get('/admin/users', {
      headers: {
        'X-Admin-Password': adminPassword
      }
    });
    return response.data;
  },
};

export default api;
